import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';
import { AccordionItemSchema } from './AccordionItem';

export const AccordionSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Accordion),
  name: z.string(),
  items: z
    .array(AccordionItemSchema)
    .nullish()
    .transform((x) => x ?? [])
});

export type Accordion = z.infer<typeof AccordionSchema>;
